import SmartbannerRepository from './SmartbannerRepository.js'

/**
 * @class
 * @implements UserRepository
 */
export default class EmptyCookieSmartbannerRepository extends SmartbannerRepository {
  setSmartbanner() {}
}
